import React from "react";
import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const TextFieldWithComponents = () => {
  return (
    <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
      <PreviewAndEditor
        title={"TextField with all components"}
        language={"js"}
        value={
          '           <FormControl error variant="standard">\n' +
          '                <InputLabel htmlFor="component-error">Name</InputLabel>\n' +
          "                <OutlinedInput\n" +
          '                    defaultValue="Composed TextField"\n' +
          "                />\n" +
          "                <FormHelperText>Error</FormHelperText>\n" +
          "            </FormControl>"
        }
      >
        <FormControl error variant="standard">
          <InputLabel htmlFor="component-error">Name</InputLabel>
          <OutlinedInput defaultValue="Composed TextField" />
          <FormHelperText>Error</FormHelperText>
        </FormControl>
      </PreviewAndEditor>
    </Box>
  );
};

export default TextFieldWithComponents;
